<script setup lang="ts">
defineProps<{ articles: CrystallizeArticle[] }>()
</script>

<template>
  <ul data-cards class="grid gap-5">
    <li v-for="article in articles" :key="article?.id">
      <NettbutikkArticleCard :article="article" />
    </li>
  </ul>
</template>

<style scoped>
[data-cards] {
  grid-template-columns: repeat(auto-fit, minmax(min(theme('spacing.80'), 100%), 1fr));
}
</style>
